import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useTheme } from "@mui/material"

import type { BarPlotView } from "types/dashboard.types"
import muiBarConfig from "./muiBar"

interface UseMuiBarConfigProps {
  view: BarPlotView
}

const useMuiBarConfig = ({ view }: UseMuiBarConfigProps) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const graphConfig = useMemo(
    () =>
      muiBarConfig({
        view,
        palette: theme.palette,
        t,
      }),
    [view, theme.palette, t],
  )

  return graphConfig
}

export default useMuiBarConfig
